// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"OtherA_TheComp__qHksf"};